export interface UnionAirportListAdd {
    year: number;
    file: File;
}